import { useCallback } from "react";
import { useIntercom } from "react-use-intercom";
import {
  recordSupportContact,
  type SupportContactSource
} from "api/support-contacts";

export const useOpenSupportChat = (source: SupportContactSource) => {
  const { show } = useIntercom();
  return useCallback(() => {
    void recordSupportContact(source);
    show();
  }, [show, source]);
};
